import {
  Box,
  Container,
  createTheme,
  FormControl,
  Link,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import Title from "../../components/Pages/Title";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState } from "react";
import Pagination from "../../components/Pagination";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";

const InternalTxs = () => {
  const loopData: number[] = [];

  const [limit, setLimit] = useState(25);
  const [total] = useState(0);
  const [page, setPage] = useState(0);

  const handleChange = (event: SelectChangeEvent) => {
    setLimit(parseInt(event.target.value));
  };

  return (
    <>
      <Title title="Contract Internal Transactions" smallTitle="" />

      <Container className="container-xxl pt-5 pb-12">
        <Box className="card">
          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box>
                <span className="text-dark content-center gap-1">
                  A total of 0 internal transactions found
                </span>
                <Box className="d-block text-muted small">
                  (Showing the last 10k records only)
                </Box>
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className="box-shadow-0">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width={1}>
                    Block
                  </TableCell>
                  <TableCell align="left">
                    <Tooltip
                      title={"Click show Datetime Format"}
                      placement="top"
                    >
                      <Link>Age</Link>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left">Parent Txn Hash</TableCell>
                  <TableCell align="left">Type</TableCell>
                  <TableCell align="left">From</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left">To</TableCell>
                  <TableCell align="left">Value</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <div className="no-data">No Data Found</div>
                  <div
                    style={{
                      height: "100px",
                    }}
                  ></div>
                </TableRow>

                {loopData.map((data) => (
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      {" "}
                      <Box className="text-dt d-flex align-items-center">
                        <CheckCircleIcon className="me-1 text-icon text-success" />
                        <Link
                          className="hash-tag text-truncate"
                          href="/tx/0x28205cb61152844610c03274bc6407bd9985e08b505ab30e8c7c0ddeb29cb581"
                        >
                          0x28205cb61152844610c03274bc6407bd9985e08b505ab30e8c7c0ddeb29cb581
                        </Link>
                      </Box>
                    </TableCell>
                    <TableCell>call</TableCell>
                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Box className="d-flex align-items-center gap-1 border px-1 border-0">
                          <Tooltip title="Contract" placement="top">
                            <AssignmentIcon className="text-icon text-secondary" />
                          </Tooltip>

                          <Tooltip
                            title="Public Tag: Fee Recipient: 0xe68...127 (0xe688b84b23f322a994a53dbf8e15fa82cdb71127)"
                            placement="top"
                          >
                            <Link
                              href="/address/0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                              className=""
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-html="true"
                              data-bs-title="0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                            >
                              0x1dDe41...45A3d708
                            </Link>
                          </Tooltip>
                        </Box>

                        <Tooltip title="Copy Address" placement="top">
                          <Link className="js-clipboard link-secondary ">
                            <ContentCopyIcon
                              className="text-icon"
                              onClick={() => navigator.clipboard.writeText("")}
                            />
                          </Link>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {" "}
                      <Box
                        className="bg-success bg-opacity-10 border border-success border-opacity-25 text-success fs-70x content-center rounded-pill mx-auto"
                        sx={{
                          width: "1.5rem",
                          height: "1.5rem",
                        }}
                      >
                        <ArrowRightAltIcon className="text-icon" />
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box className="d-flex d-flex align-items-center gap-1">
                        <Box className="d-flex align-items-center gap-1 border px-1 border-0">
                          <Tooltip title="Contract" placement="top">
                            <AssignmentIcon className="text-icon text-secondary" />
                          </Tooltip>

                          <Tooltip
                            title="Public Tag: Fee Recipient: 0xe68...127 (0xe688b84b23f322a994a53dbf8e15fa82cdb71127)"
                            placement="top"
                          >
                            <Link
                              href="/address/0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                              className=""
                              data-bs-toggle="tooltip"
                              data-bs-trigger="hover"
                              data-bs-html="true"
                              data-bs-title="0x1dde41f92d3f7a46ce6f6de24ab3a94a45a3d708"
                            >
                              0x1dDe41...45A3d708
                            </Link>
                          </Tooltip>
                        </Box>

                        <Tooltip title="Copy Address" placement="top">
                          <Link className="js-clipboard link-secondary ">
                            <ContentCopyIcon
                              className="text-icon"
                              onClick={() => navigator.clipboard.writeText("")}
                            />
                          </Link>
                        </Tooltip>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Tooltip title="0.027354773076765 UPC" placement="top">
                        <Box>0.027354773 UPC</Box>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box
                id="ContentPlaceHolder1_pageRecords"
                className="d-flex align-items-center gap-2 text-nowrap text-muted"
              >
                Show:
                <FormControl sx={{ m: 1, minWidth: 70 }}>
                  <Select
                    value={limit.toString()}
                    onChange={handleChange}
                    displayEmpty
                    size="small"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        fontSize: "12px;",
                      }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={25}
                    >
                      25
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={50}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={100}
                    >
                      100
                    </MenuItem>
                  </Select>
                </FormControl>
                Records
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default InternalTxs;
